import { v4 as uuidv4 } from "uuid"; 

function chillHop() {
    return [

        {
            name:"De Corazon A Corazon",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-2.png",
            id: uuidv4(),
            color: ["#F24933", "#F9B437"],
            audio: "https://ia800204.us.archive.org/22/items/DeCorazonACorazon/PalabraEnAccion-DeCorazonAcorazon.mp3",
            active: true,
        },
        {
            name:"Yo Te Amo",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-4.png",
            id: uuidv4(),
            color: ["#D7B0D5", "#CBDFE0"],
            audio: "https://ia800205.us.archive.org/12/items/YoTeAmo_938/PalabraEnAccionYoTeAmo.mp3",
            active: false,
        },
        {
            name:"Cuando Estoy En Tu Casa",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-7.png",
            id: uuidv4(),
            color: ["#D7B0D5", "#CBDFE0"],
            audio: "https://ia800205.us.archive.org/1/items/CuandoEstoyEnTuCasa/Servando-CuandoEstoyEnTuCasa.mp3",
            active: false,
        },
        {
            name:"SUBLIME GRACIA",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-12.png",
            id: uuidv4(),
            color: ["#1D2731", "#F17E76"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2003%20-%20SUBLIME%20GRACIA.mp3",
            active: false,
        },
        {
            name:"Cuan Grande Es El",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-11.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2001%20-%20CUAN%20GRANDE%20ES%20EL.mp3",
            active: false,
        },
        {
            name:"Oh tu Fidelidad",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-8.png",
            id: uuidv4(),
            color: ["#845648","#FDFBDF"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2002%20-%20OH%20TU%20FIDELIDAD.mp3",
            active: false,
        },
        {
            name:"LOORES DAD A CRISTO EL REY",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-5.png",
            id: uuidv4(),
            color: ["#578CCE", "#E9D6D0"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2004%20-%20LOORES%20DAD%20A%20CRISTO%20EL%20REY.mp3",
            active: false,
        },
        {
            name:"OH CUAN DULCE",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-10.png",
            id: uuidv4(),
            color: ["#191516", "#82698E"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2005%20-%20OH%20CUAN%20GRANDE%20ES%20EL.mp3",
            active: false,
        },
        {
            name:"VICTORIA EN CRISTO",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-9.png",
            id: uuidv4(),
            color: ["#7BC8DD", "#D64A59"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2006%20-%20VICTORIA%20EN%20CRISTO.mp3",
            active: false,
        },
        {
            name:"Oh que Amigo",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-6.png",
            id: uuidv4(),
            color: ["#FDE1A9", "#A46874"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2007%20-%20OH%20QUE%20AMIGO%20.mp3",
            active: false,
        },
        {
            name:"SANTO,SANTO,SANTO",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-2.png",
            id: uuidv4(),
            color: ["#D7B0D5", "#CBDFE0"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2008%20-%20SANTO%2C%20SANTO%2C%20SANTO.mp3",
            active: false,
        },
        {
            name:"TU INCOPARABLE AMOR",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-4.png",
            id: uuidv4(),
            color: ["#1D2731", "#F17E76"],
            audio: "https://ia601901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2009%20-%20TU%20INCOMPARABLE%20AMOR.mp3",
            active: false,
        },
        {
            name:"LA CRUZ DE JESUS",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-7.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2010%20-%20LA%20CRUZ%20DE%20JESUS.mp3",
            active: false,
        },
        {
            name:"Prefiero a Jesus",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-3.png",
            id: uuidv4(),
            color: ["#D7B0D5", "#CBDFE0"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2012%20-%20PREFIERO%20A%20JESUS.mp3",
            active: false,
        },
        {
            name:"Jubilosos te adoramos",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-1.png",
            id: uuidv4(),
            color: ["#1D2731", "#F17E76"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2013%20-%20JUBILOSOS%20TE%20ADORAMOS.mp3",
            active: false,
        },
        {
            name:"Alcance Salvacion",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-12.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2014%20-%20ALCANCE%20SALVACION.mp3",
            active: false,
        },
        {
            name:"EN JESUCRISTO MARTIR DE LA PAZ",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-11.png",
            id: uuidv4(),
            color: ["#D7B0D5", "#CBDFE0"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2015%20-%20EN%20JESUCRISTO%20MARTIR%20DE%20PAZ.mp3",
            active: false,
        },
        {
            name:"DULCE ORACION",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-8.png",
            id: uuidv4(),
            color: ["#1D2731", "#F17E76"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2016%20-%20DULCE%20ORACION.mp3",
            active: false,
        },
        {
            name:"Oh que tuviera lenguas mil",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-5.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2017%20-%20OH%20QUE%20TUVIERA%20LENGUAS%20MIL.mp3",
            active: false,
        },
        {
            name:"A SOLAS",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-10.png",
            id: uuidv4(),
            color: ["#D7B0D5", "#CBDFE0"],
            audio: "https://ia601901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2018%20-%20A%20SOLAS.mp3",
            active: false,
        },
        {
            name:"TE QUIERO MI SENOR",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-9.png",
            id: uuidv4(),
            color: ["#1D2731", "#F17E76"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2019%20-%20TE%20QUIERO%20MI%20SENOR.mp3",
            active: false,
        },
         {
            name:"ROCA DE LA ETERNIDAD",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-6.png",
            id: uuidv4(),
            color: ["#1D2731", "#F17E76"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2021%20-%20ROCA%20DE%20LA%20ETERNIDAD.mp3",
            active: false,
        },
         {
            name:"Alma bendice al Senor",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-2.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2022%20-%20ALMA%20BENDICE%20AL%20SENOR.mp3",
            active: false,
        },
        {
            name:"PON TUS OJOS EN CRISTO",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-4.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2023%20-%20PON%20TUS%20OJOS%20EN%20CRISTO.mp3",
            active: false,
        },
        {
            name:"Tal como soy",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-7.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2024%20-%20TAL%20COMO%20SOY.mp3",
            active: false,
        },
        {
            name:"ALABAD AL GRAN REY",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-3.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/25%20Himnos%20Favoritos%20-%2025%20-%20ALABAD%20AL%20GRAN%20REY.mp3",
            active: false,
        },
        {
            name:"ANTE EL TRONO CELESTIAL",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-1.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/ANTE%20EL%20TRONO%20CELESTIAL%5B1%5D.mp3",
            active: false,
        },
        {
            name:"Brilla Jesus himno cristiano",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-12.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia601901.us.archive.org/11/items/himnosycanticos/Brilla%20Jes%C3%BAs%20himno%20cristiano.mp3",
            active: false,
        },
        {
            name:"Carinoso Salvador Alabanzare",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-11.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/Cari%C3%B1oso%20Salvador%20%20%20Alabanzare.mp3",
            active: false,
        },
        {
            name:"Carinoso Salvador Alabanzare unplug",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-8.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/Cari%C3%B1oso%20SalvadorAlabanzare%20unplug.mp3",
            active: false,
        },
        {
            name:"Castillo fuerte es nuestro Dios Cantado",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-5.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia601901.us.archive.org/11/items/himnosycanticos/Castillo%20fuerte%20es%20nuestro%20Dios%20%20%20Cantado.mp3",
            active: false,
        },
        {
            name:"Cerca de Ti Senor himno",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-10.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia601901.us.archive.org/11/items/himnosycanticos/Cerca%20de%20Ti%20Se%C3%B1or%20himno.mp3",
            active: false,
        },
        {
            name:"Cuan dulce el nombre de Jesus",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-9.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/Cuan%20dulce%20el%20nombre%20de%20Jes%C3%BAs.mp3",
            active: false,
        },
        {
            name:"DEMOS GRACIAS AL SENOR",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-6.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/DemosGracias%20Al%20Se%C3%B1or-Helen-mp3.mp3",
            active: false,
        },
        {
            name:"El Poder de la Cruz himno cristiano",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-2.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia601901.us.archive.org/11/items/himnosycanticos/El%20Poder%20de%20la%20Cruz%20himno%20cristiano.mp3",
            active: false,
        },
        {
            name:"Fija tus ojos en Cristo himno cristiano",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-4.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/Fija%20tus%20ojos%20en%20Cristo%20himno%20cristiano%5B1%5D.mp3",
            active: false,
        },
        {
            name:"Oh Tu fidelidad himno cristiano",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-7.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/Oh%20Tu%20fidelidad%20himno%20cristiano%5B1%5D.mp3",
            active: false,
        },
        {
            name:"Oh jovenes venid",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-3.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801604.us.archive.org/35/items/himnosdeadoracion/%25C2%25A1Oh%21%20jovenes%20venid.mp3",
            active: false,
        },
        {
            name:"Agradecido",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-1.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801604.us.archive.org/35/items/himnosdeadoracion/Agradecido.mp3",
            active: false,
        },
         {
            name:"Castillo fuerte es nuestro Dios",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-12.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia601604.us.archive.org/35/items/himnosdeadoracion/Castillo%20fuerte%20es%20nuestro%20Dios.mp3",
            active: false,
        },
         {
            name:"Con Jesus por doquier sin temor ire",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-11.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801604.us.archive.org/35/items/himnosdeadoracion/Con%20Jesus%20por%20doquier%20sin%20temor%20ire.mp3",
            active: false,
        },
         {
            name:"Cristo mi vida ofrezco",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-8.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia601604.us.archive.org/35/items/himnosdeadoracion/Cristo%20mi%20vida%20ofrezco.mp3",
            active: false,
        },
         {
            name:"Majestad",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-5.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia800207.us.archive.org/26/items/HimnosYCoros/14.Majestad.mp3",
            active: false,
        },
         {
            name:"Alabado sea el Senor, el Todopoderoso",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-10.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia800100.us.archive.org/24/items/Instrumentales02/Alabado%20sea%20el%20Se%C3%B1or%2C%20el%20Todopoderoso.mp3",
            active: false,
        },
        {
            name:"Instrumental-Bellas palabras de vida",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-8.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia601901.us.archive.org/11/items/himnosycanticos/Instrumental-bellasPalabrasDeVida.mp3",
            active: false,
        },
        {
            name:"Instrumental-Carinoso Salvador",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-5.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/Instrumental-cariosoSalvador.mp3",
            active: false,
        },
        {
            name:"Instrumental-Castillo fuerte",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-10.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/Instrumental-castilloFuerte.mp3",
            active: false,
        },
        {
            name:"Instrumental-Cuan grande es El",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-9.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia801901.us.archive.org/11/items/himnosycanticos/Instrumental-cunGrandeEsl.mp3",
            active: false,
        },
        {
            name:"Cuerdas De Amor",
            artist: "Canticos y Alabanzas",
            cover: "https://manuappshome.files.wordpress.com/2020/07/canticos-6.png",
            id: uuidv4(),
            color: ["#008781", "#cfc08c"],
            audio: "https://ia600206.us.archive.org/32/items/CuerdasDeAmor/BrigadasDeAmor-CuerdasDeAmor.mp3",
            active: false,
        },
    ];
}

export default chillHop;

